import React from 'react';
import Hero from './Hero';
import Features from './Features';
import CTABanner from './CTABanner';
import ScienceSection from './science/ScienceSection';
import Footer from './Footer';
import { APP_URL } from '../../config';

// The app now has separate Log In / Sign Up screens (no router over there —
// it reads this query param once at mount). Sign-in intent and
// get-started/conversion intent land on different screens.
const goToLogin = () => { window.location.href = `${APP_URL}?mode=login`; };
const goToSignUp = () => { window.location.href = `${APP_URL}?mode=signup`; };

// CTAs all hand off to the app domain rather than doing anything on this page —
// deliberately more than one shot at conversion now that there's no
// scroll-to-signup anchor mid-page (SignUp itself moved to app.vesna.health).
const LandingPage = () => (
  <div style={{ width: '100%' }}>
    <Hero onSignIn={goToLogin} onGetStarted={goToSignUp} />
    <Features />
    <ScienceSection />
    <CTABanner
      eyebrow="Your journey starts here"
      heading="You're one step away from understanding what your body has been trying to tell you."
      onGetStarted={goToSignUp}
    />
    <Footer />
  </div>
);

export default LandingPage;
